var map = {
	"./no1.png": "e981",
	"./no1_bg.png": "66d1",
	"./no2.png": "e89b",
	"./no2_bg.png": "a2c3",
	"./no3.png": "d37f",
	"./no3_bg.png": "0a5d",
	"./nodata_ranking.png": "825f",
	"./normal_switch.png": "6353",
	"./normal_switch_left.png": "9593"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f91";